export const events = [
    {
        id:1,
        title: "Networking Evening",
        hosted_by: "WeAreWeb & Co.",
        date: "July 14, 2021",
        location: "The BeeHive Offices",
        abstract: "Class aptent taciti sociosqu ad litora torquent per conubia nostra. ",
        description: "Class aptent taciti sociosqu ad litora torquent per conubia nostra, per inceptos himenaeos. Sed nisi ipsum, posuere nec mauris eu, vulputate blandit nulla. In scelerisque nisl quis nulla imperdiet lacinia. Donec sit amet vestibulum eros. Quisque congue malesuada lectus. Nullam faucibus diam ut ultrices ultrices."
    },
    {
        id:2,
        title: "JavaScript Lecture",
        hosted_by:"The IT People",
        date: "August 25, 2021",
        location: "The BeeHive Offices",
        abstract: "Class aptent taciti sociosqu ad litora torquent per conubia nostra. ",
        description: "Class aptent taciti sociosqu ad litora torquent per conubia nostra, per inceptos himenaeos. Sed nisi ipsum, posuere nec mauris eu, vulputate blandit nulla. In scelerisque nisl quis nulla imperdiet lacinia. Donec sit amet vestibulum eros. Quisque congue malesuada lectus. Nullam faucibus diam ut ultrices ultrices."
    },
    {
        id:3,
        title: "IT Meet and Greet",
        hosted_by: "DevOps Ltd.",
        date: "October 12, 2021",
        location: "The BeeHive Offices",
        abstract: "Class aptent taciti sociosqu ad litora torquent per conubia nostra. ",
        description: "Class aptent taciti sociosqu ad litora torquent per conubia nostra, per inceptos himenaeos. Sed nisi ipsum, posuere nec mauris eu, vulputate blandit nulla. In scelerisque nisl quis nulla imperdiet lacinia. Donec sit amet vestibulum eros. Quisque congue malesuada lectus. Nullam faucibus diam ut ultrices ultrices."
    },
];